import type { AvE2EProps } from "../../types";

type FormattedNumberProps = AvE2EProps & {
  value: string;
  locale: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  options?: Intl.NumberFormatOptions;
  suffix?: string;
};

export function FormattedNumber({
  value,
  locale,
  testIdPrefix,
  minimumFractionDigits = 2,
  maximumFractionDigits = 2,
  options,
  suffix = "",
}: FormattedNumberProps) {
  const castedFloat = parseFloat(value);

  if (!Number.isFinite(castedFloat)) {
    return <span data-testid={testIdPrefix + "-value"}>-</span>;
  }

  const formatter = new Intl.NumberFormat(locale, {
    minimumFractionDigits,
    maximumFractionDigits,
    ...(options || {}),
  });

  return (
    <span data-testid={testIdPrefix + "-value"}>
      {formatter.format(castedFloat)} {suffix}
    </span>
  );
}
